import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { Subscription } from 'rxjs';
import { AtlasTranslateService } from './translate.service';

@Pipe({
  name: 'translate',
  pure: false,
})
export class AtlasTranslatePipe implements PipeTransform, OnDestroy {
  value: string = '';
  private onTranslationChange: Subscription;

  constructor(private translate: AtlasTranslateService, private _ref: ChangeDetectorRef) {
  }

  transform(key: string, ...args: any[]): any {
    if (!key || key.length === 0) {
      return key;
    }

    let defaultText = '';
    if (args && args.length === 1) {
      defaultText = args[0];
    }

    this._dispose();

    if (!this.onTranslationChange) {
      this.onTranslationChange = this.translate
          .stream(key, defaultText)
          .subscribe((translation: string) => {
            this.value = translation;
            this._ref.markForCheck();
          });
    }
    return this.value;
  }

  private _dispose(): void {
    if (typeof this.onTranslationChange !== 'undefined') {
      this.onTranslationChange.unsubscribe();
      this.onTranslationChange = undefined;
    }
  }

  ngOnDestroy(): void {
    this._dispose();
  }
}
